import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FilesProvider } from '../../providers/files-provider';
import { File } from "../../../common/models/file";

import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { FileType } from "../../../common/models/file-type";
import { ConfigProvider } from "../../../config-provider.service";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import FileSaver from 'file-saver';
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { NgIf } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'files-image-viewer-dialog',
  providers: [],
  styleUrls: ['./image-viewer-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogClose,
    MatDialogTitle,
    NgIf,
    MatButton,
    MatProgressBar,
    MatProgressSpinner,
    MatDialogContent,
    MatDialogActions,
    TranslateModule
  ],
  templateUrl: './image-viewer-dialog.html'
})
export class FilesImageViewerDialogComponent implements AfterViewInit {
    public isLoading = true;
    public isDownloadLoading = false;
    public src: any = null;

    public title = '';
    public file: File = new File({});
    public type: FileType = new FileType({});
    public downloadApi: string | null = null;
    public downloadEnabled = true;
    private blobData: Blob;
    constructor(
        public conf: ConfigProvider,
        public dialog: MatDialogRef<FilesImageViewerDialogComponent>,
        public utils: UtilsProvider,
        public currentUser: CurrentUser,
        private _files: FilesProvider,
        private _translater: TranslateService,
        private _changeDetector: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.file = this._data.file;
        this.title = this.file ? this.file.name : this._data.title;
        this.type = this._data.type;
        this.downloadApi = this._data.downloadApi;
        this.blobData = this._data.data;
        this.downloadEnabled = this._data.downloadEnabled !== false;
    }

    public ngAfterViewInit() {
        this.loadImage().subscribe({
            next: () => {
              this.isLoading = false;
              this.isDownloadLoading = false;
              this._changeDetector.detectChanges();
            },
            error: (error) => this.onError(error)
        });
    }

    public onDownloadClicked(): void {
        if (this.downloadApi) {
            this.isDownloadLoading = true;
            this._files.downloadFile(this.downloadApi, this.file).subscribe({
                next: (fileData: any) => {
                  const fileName: string = this.file.name + '.' + this.type.extension;
                      FileSaver.saveAs(fileData, fileName);
                      this.isDownloadLoading = false;
                },
                error: (error) => this.onError(error)
            });
        }
    }

    private loadImage(): Observable<any> {
      if (this.blobData) {
          this.readImage();
          return of(null);
      } else if (this.downloadApi) {
          return this._files.downloadFile(this.downloadApi, this.file).pipe(
            map((fileData: any) => {
                this.blobData = fileData;
                this.readImage();
                return;
            }),
          );
      } else {
          throw new Error('No download API Set');
      }
    }

    private readImage(): void {
        // tiré de : https://stackoverflow.com/questions/45530752/getting-image-from-api-in-angular-4
        const reader: FileReader = new FileReader();
        reader.addEventListener('load', () => this.src = reader.result, false);
        reader.readAsDataURL(this.blobData);
    }

    private onError(error: any): void {
        this.isDownloadLoading = false;
        this.isLoading = false;
    }
}
